const BetweenPages = () => {
	return (
		<></>
	);
};

export default BetweenPages;